import type { LevelScript } from '@nebulark/engine';

export const STAGE2: LevelScript = {
  id: 'stage2',
  durationSec: 45,
  scrollSpeed: 150,
  bossId: 'boss-stage1',
  spawns: [
    // === 0-8s: aggressive opener ===
    { t: 0.5, enemyId: 'grunt-straight', x: 80  },
    { t: 0.5, enemyId: 'grunt-straight', x: 180 },
    { t: 0.5, enemyId: 'grunt-straight', x: 280 },
    { t: 2,   enemyId: 'weaver-sine',    x: 130 },
    { t: 2,   enemyId: 'weaver-sine',    x: 230 },
    { t: 3,   enemyId: 'sniper-aimed',   x: 180 },
    { t: 4,   enemyId: 'swarmer', x: 90,  group: 'swarm-a', count: 5, spacing: 22 },
    { t: 5,   enemyId: 'grunt-straight', x: 60  },
    { t: 5,   enemyId: 'grunt-straight', x: 300 },
    { t: 7,   enemyId: 'sniper-aimed',   x: 100 },
    { t: 7,   enemyId: 'sniper-aimed',   x: 260 },

    // === 8-16s: mixed assault ===
    { t: 8,   enemyId: 'swarmer', x: 180, group: 'swarm-b', count: 5, spacing: 22 },
    { t: 9,   enemyId: 'orbit-fighter', x: 180, group: 'orbit-s2-a', count: 6, spacing: 0 },
    { t: 9,   enemyId: 'weaver-sine',    x: 60  },
    { t: 9,   enemyId: 'weaver-sine',    x: 300 },
    { t: 10,  enemyId: 'sniper-aimed',   x: 180 },
    { t: 11,  enemyId: 'grunt-straight', x: 80  },
    { t: 11,  enemyId: 'grunt-straight', x: 180 },
    { t: 11,  enemyId: 'grunt-straight', x: 280 },
    { t: 13,  enemyId: 'swarmer', x: 60,  group: 'swarm-c', count: 5, spacing: 22 },
    { t: 13,  enemyId: 'swarmer', x: 250, group: 'swarm-d', count: 5, spacing: 22 },
    { t: 15,  enemyId: 'sniper-aimed',   x: 90  },
    { t: 15,  enemyId: 'sniper-aimed',   x: 270 },

    // === 16-24s: escalation ===
    { t: 16,  enemyId: 'weaver-sine',    x: 80  },
    { t: 16,  enemyId: 'weaver-sine',    x: 180 },
    { t: 16,  enemyId: 'weaver-sine',    x: 280 },
    { t: 17,  enemyId: 'snake-fighter',  x: 180, group: 'snake-s2-a', count: 8, spacing: 0 },
    { t: 18,  enemyId: 'swarmer', x: 140, group: 'swarm-e', count: 7, spacing: 20 },
    { t: 19,  enemyId: 'sniper-aimed',   x: 60  },
    { t: 19,  enemyId: 'sniper-aimed',   x: 180 },
    { t: 19,  enemyId: 'sniper-aimed',   x: 300 },
    { t: 21,  enemyId: 'grunt-straight', x: 60  },
    { t: 21,  enemyId: 'grunt-straight', x: 120 },
    { t: 21,  enemyId: 'grunt-straight', x: 240 },
    { t: 21,  enemyId: 'grunt-straight', x: 300 },
    { t: 23,  enemyId: 'swarmer', x: 80,  group: 'swarm-f', count: 5, spacing: 22 },
    { t: 23,  enemyId: 'swarmer', x: 240, group: 'swarm-g', count: 5, spacing: 22 },

    // === 24-35s: gauntlet ===
    { t: 24,  enemyId: 'sniper-aimed',   x: 120 },
    { t: 24,  enemyId: 'sniper-aimed',   x: 240 },
    { t: 25,  enemyId: 'weaver-sine',    x: 180 },
    { t: 26,  enemyId: 'swarmer', x: 160, group: 'swarm-h', count: 7, spacing: 20 },
    { t: 27,  enemyId: 'snake-fighter',  x: 270, group: 'snake-s2-b', count: 8, spacing: 0 },
    { t: 28,  enemyId: 'grunt-straight', x: 60  },
    { t: 28,  enemyId: 'grunt-straight', x: 180 },
    { t: 28,  enemyId: 'grunt-straight', x: 300 },
    { t: 29,  enemyId: 'sniper-aimed',   x: 80  },
    { t: 29,  enemyId: 'sniper-aimed',   x: 180 },
    { t: 29,  enemyId: 'sniper-aimed',   x: 280 },
    { t: 31,  enemyId: 'swarmer', x: 90,  group: 'swarm-i', count: 5, spacing: 22 },
    { t: 31,  enemyId: 'swarmer', x: 250, group: 'swarm-j', count: 5, spacing: 22 },
    { t: 33,  enemyId: 'orbit-fighter', x: 270, group: 'orbit-s2-b', count: 6, spacing: 0 },
    { t: 33,  enemyId: 'weaver-sine',    x: 60  },
    { t: 33,  enemyId: 'weaver-sine',    x: 180 },
    { t: 33,  enemyId: 'weaver-sine',    x: 300 },
    { t: 35,  enemyId: 'sniper-aimed',   x: 150 },
    { t: 35,  enemyId: 'sniper-aimed',   x: 210 },
    // Boss spawns at t=45 (durationSec)
  ],
};
